import errorAudio from "../assets/audios/errorAudio.mp3";

export function playAudio(filePath: string) {
  const audio = new Audio(filePath);
  audio.play().catch((error) => console.error(error));
}

export function playErrorAudio() {
  playAudio(errorAudio);
}
